import { Notification } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/** Центр уведомлений и настройка каналов по типам (ПОРТ-60). Все роли; открывается из колокольчика и профиля. */
export const section = defineSection({
  id: 'notifications.center',
  area: 'clinic',
  path: 'notifications',
  roles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'DOCTOR', 'FRONT_DESK', 'HR', 'ACCOUNTANT'],
  icon: Notification,
  titleKey: 'notifications:title',
  namespaces: ['portal'],
  navGroup: 'work',
  order: 50,
  nav: false,
  load: () => import('./NotificationsPage'),
});
